var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'button-tab',
    {
      'button-tab--selected': _vm.isSelected,
      'button-tab--unselected': !_vm.isSelected
    }
  ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"button-tab__text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }